import { CarouselLoad } from "./carousel-load";

const carouselComponents = document.querySelectorAll(".js-carousel-component");

const carouselComponentConfig = {
  init: false,
  loop: false,
  simulateTouch: false,
  navigation: {
    prevEl: ".js-carousel-component-prev",
    nextEl: ".js-carousel-component-next",
  },
  slidesPerView: "auto",
  slidesPerGroup: 1,
  spaceBetween: 15,
  watchSlidesProgress: true,
  watchSlidesVisibility: true,
  breakpointsInverse: true,
  watchOverflow: true,
};

if (carouselComponents) {
  for (const carouselComponent of carouselComponents) {
    const mobileScrollable = "mobileScrollable" in carouselComponent.dataset || false;
    const dataConfig = carouselComponent.dataset.config || "{}";
    const configWithData = {
      ...carouselComponentConfig,
      ...JSON.parse(dataConfig),
    };
    const carouselId = `js-carousel-id-${carouselComponent.dataset.carouselId}`;
    carouselComponent.classList.add(carouselId);

    // Rename breakpoints
    if (configWithData.breakpoints) {
      if (configWithData.breakpoints.tablet) {
        configWithData.breakpoints["768"] = configWithData.breakpoints.tablet;
        delete configWithData.breakpoints.tablet;
      }
      if (configWithData.breakpoints.desktop) {
        configWithData.breakpoints["992"] = configWithData.breakpoints.desktop;
        delete configWithData.breakpoints.desktop;
      }
    }

    if (mobileScrollable) {
      const slidesList = carouselComponent.querySelector(".js-carousel-component-slides-list");
      slidesList.style.gap = `${configWithData.spaceBetween}px`;
      slidesList.style.gridGap = `${configWithData.spaceBetween}px`;
    }

    // eslint-disable-next-line no-new
    new CarouselLoad(`.${carouselId}`, configWithData, mobileScrollable, true);
  }
}
